import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 bg-green-50 border-y border-green-100" data-id="element-43">
      <div className="container mx-auto px-4" data-id="element-44">
        <FadeIn data-id="element-45">
          <div className="max-w-3xl mx-auto flex flex-col md:flex-row items-center gap-6 text-center md:text-left" data-id="element-46">
            <div className="shrink-0" data-id="element-47">
              <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center" data-id="element-48">
                <ShieldCheck className="w-10 h-10 text-green-600" data-id="element-49" />
              </div>
            </div>
            <div data-id="element-50">
              <h2 className="text-2xl md:text-3xl font-bold text-slate-900 mb-3" data-id="element-51">
                Garantía "Sin Vueltas" de 7 Días. ✅
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed" data-id="element-52">
                Probá el pack completo. Si en 7 días sentís que no es para vos,
                nos escribís y te devolvemos el 100% de tu dinero. Sin
                preguntas, sin riesgos.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}